import { Component, ChangeDetectionStrategy } from '@angular/core';
import { IBaseEntityType } from '@app/shared/types/entities/base/base.type';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams, RowNode } from 'ag-grid-community';
import { get, isFunction, noop } from 'lodash';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'xvi-icon-button-renderer',
  templateUrl: './icon-button-renderer.component.html',
  styleUrls: ['./icon-button-renderer.component.scss'],
})
export class IconButtonRendererComponent implements AgRendererComponent {
  public params: ICellRendererParams;
  public data: IBaseEntityType;

  public icon: string;
  public class: string;
  public click: (event: {
    node: RowNode;
    data: IBaseEntityType;
    event: Event;
  }) => void;

  public constructor() {}

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    this.data = params.node.data;

    this.icon = get(params, 'icon', '');
    this.class = get(params, 'class', '');
    this.click = get(params, 'click', noop);
  }

  public refresh(): boolean {
    return true;
  }

  public handleBtnClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    if (isFunction(this.click)) {
      this.click({ node: this.params.node, data: this.data, event });
    }
  }
}
